import { upload } from "@testing-library/user-event/dist/upload";
import { send } from "process";
import { pipeline } from "stream";

const en = {
  welcome: "Welcome",
  language: "Language",
  switch_language: "Switch Language",
  about: "About Us",
  pipeline: "Pipelines",
  models: "Models",
  login: "Login",
  register: "Register",
  ai_services: "AI Services for Kazakh Language",
  goal: "Our goal is to develop a user-friendly application for Kazakh language AI services, enabling users to automate tasks and digitize data.",
  our_services: "Our Services",
  text_to_speech: "Text to Speech",
  llm: "Large Language Model",
  speech_to_text: "Speech to Text",
  named_entity_recognition: "Named Entity Recognition",
  ocr: "Optical Character Recognition",
  image_captioning: "Image Captioning",
  footer: {
    rights: "All rights reserved.",
  },
  text_to_speech_desc:
    "Convert written text into spoken words effortlessly with our TTS technology.",
  named_entity_recognition_desc:
    "Extract and classify key information from unstructured text seamlessly.",
  llm_desc:
    "A Kazakh language LLM trained for various NLP tasks like question answering.",
  speech_to_text_desc:
    "Convert speech into text easily for seamless transcription.",
  ocr_desc:
    "Extract text from images and scanned documents with our OCR technology.",
  login_desc: "Login to access more features.",
  register_desc: "Register to access more features.",
  username: "Username",
  password: "Password",
  enterUsername: "Enter your username",
  enterPassword: "Enter your password",
  enter_text: "Enter text to convert to speech",
  convertToSpeech: "Convert to Speech",
  question: "Question",
  response: "Response",
  enterQuestion: "Enter your question",
  text_summarization: "Text Summarization",
  qa: "Question Answering",
  machine_translation: "Machine Translation",
  optical_character_recognition_desc:
    "Extracts text from images or scanned documents.",
  image_captioning_desc: "Generates a descriptive caption for an image.",
  text_summarization_desc: "Produces a concise summary of a given text.",
  question_answering_desc:
    "Answers questions based on a given context or passage.",
  machine_translation_desc: "Translates text from one language to another.",
  generated_images: "Generated Images",
  generate_images: "Generate Images",
  generated_videos: "Generated Videos",
  generate_videos: "Generate Videos",
  no_images: "No images generated yet.",
  no_videos: "No videos generated yet.",
  enter_your_text: "Enter your text",
  enter_your_video_text: "Enter your text for video generation",
  recognized_entities: "Recognized Entities",
  query_history: "Query History",
  extract_entities: "Extract Entities",
  llm_chat: "Large Language Model Chat",
  start_new_chat: "Start a new chat",
  send: "Send",
  search: "Search",
  no_chat_seleted: "No chat selected",
  search_results: "Search Results",
  text_id: "Text ID",
  text_score: "Score",
  transcription: "Transcription",
  transcription_desc: "Transcription will appear here",
  stop_recording: "Stop Recording",
  start_recording: "Start Recording",
  extracted_text: "Extracted Text",
  extract_text: "Extract Text",
  upload_image: "Upload Image",
  extracted_text_title: "Extracted text will appear here",
  uploaded_image: "Uploaded Image",
  generated_caption: "Generated Caption",
  generated_text_placeholder: "Generated text will appear here",
  enter_the_text: "Enter the text",
  enter_question: "Enter the question",
  get_answer: "Get Answer",
  answer: "Answer",
  translate: "Translate",
  translated_text: "Translated Text",
  translation_successful: "Text has been translated successfully!,",
  document_qa: "Document Q&A",
  upload_file: "Upload File",
  uploaded_file: "Uploaded File",
  ask_question: "Ask a question about the document",
  ocrr: "Pipelined models to retrieve answers based on the provided document",
};

export default en;
